import { Button } from "antd";

interface PolicyStepProps {
  onNext: () => void;
  onBack: () => void;
}

export default function PolicyStep({ onNext, onBack }: PolicyStepProps) {
  const policyContent = `好盒器會員服務條款

「好盒器」是由人嶼物股份有限公司（以下簡稱本公司）所經營開發之服務，人嶼物股份有限公司為臺灣臺南市政府核准設立之公司，其登記地址為臺南市東區長榮路三段50巷5號1樓。於您使用「好盒器」服務（以下簡稱本服務）前，請先詳細閱讀各項服務條款，一旦您完成好盒器之會員註冊程序或開始使用本服務時，即表示您已閱讀、瞭解並同意接受本服務條款之所有內容，並完全接受本服務現有與未來衍生的服務項目及內容。

一、註冊與使用說明
就好盒器會員帳戶之註冊及使用事宜，您聲明及保證以下事項：
1. 當您註冊成為本服務會員或使用本服務時，必須提供最新且真實的個人資料，且如個人資料有異動時會即時更新，以保障您的權益。
2. 如果您是未滿十八歲之未成年人或依中華民國法令須事先得第三人同意始得行使權利或負擔義務者，則您必須取得父母、監護人或該第三人同意後，才可以註冊及使用本服務。當您完成註冊或開始使用服務時，即視為您的父母、監護人或該第三人已經充分審閱、了解及同意本服務條款，並同意您註冊成為會員及使用服務。
3. 您並非為其他人註冊帳號。
4. 您並未也不會註冊兩個以上的個人帳號。
5. 如果您的帳號遭停權，您不會註冊另一個帳號。
6. 您同意本服務隨時得以電話、簡訊、通訊軟體、電子郵件或其他方式提供您本服務之各種服務項目及相關優惠訊息。
7. 您理解並同意任何以您的帳號於本服務中所有行為，均視為您本人或經您授權所為，您可能因此必須負擔相應的法律責任，因此您不會讓其他人透過您的帳號使用本服務。
8. 本服務將依法保護您所提供之個人資料。

二、服務內容
1. 本服務提供好盒器會員（以下稱會員或使用者）使用本服務架設之相關系統技術平台，使用者可透過本服務瀏覽第三方合作店鋪（以下統稱合作店舖）之位置與營業時間。
2. 會員可透過本服務向合作店鋪借用容器，並於指定時間內歸還至指定合作店鋪或好盒器自助歸還站。
3. 本服務提供系統技術平台與相關設備予合作店鋪，使合作店鋪可操作與接收與本服務相關之資訊。
4. 本服務提供符合國家食品器具檢驗標準之容器，並使用專業清洗及消毒設備，且定期委外公正SGS檢驗本服務提供之容器。

三、使用義務與承諾
1. 您承諾絕不為任何非法目的或任何非法方式使用本服務。
2. 您同意並保證不得利用本服務從事侵犯他人權益或違法之行為，並配合公平使用租借原則，不以投機方式連續長期佔用，造成其他使用者的不便。
3. 本服務之循環容器僅限乘裝茶飲使用，不得移用於其他無相關之用途。

四、個人資料及隱私保護
1. 本公司將依法盡商業上合理之努力保護您的個人資料及隱私。您已瞭解並確認本公司根據個人資料保護法規定，明確告知與個人資料保護有關事項如下：
蒐集之目的
2. 本公司基於個人資料保護法及相關法令之規定取得您的個人資料，目的在於提供良好服務及執行職務或業務之必要範圍內蒐集、處理及利用您的個人資料。您同意本公司以您所提供的個人資料確認您的身份、與您進行連絡、提供您本公司或合作夥伴之相關服務及資訊，包括但不限於社群訊息推播、活動推廣、新服務、新產品之通知等用途，以及其他隱私權保護政策規範之使用方式。
蒐集之類別
3. 您可依您的需要提供個人資料，包含姓名、連絡方式，包括但不限於電話、E-MAIL或地址或其他得以直接或間接識別您個人之資料。
利用期間、地區及對象
4. 期間：本公司存續期間或依法令之資料保存期間。
5. 地區：中華民國領域。
6. 對象：本公司與其旗下所屬業務範圍內容，以及其他與本公司有業務往來或合作之機構。
7. 您對於本公司保有您的個人資料部分，日後您仍得享有下列權利：
8. 得向本公司請求停止蒐集、處理或利用及請求刪除您的個人資料。
9. 本公司利用個人資料行銷，您表示拒絶接受行銷時，於法定合理期間本公司即不得以行銷之名義利用您的個人資料。
10.如您拒絕提供部分個人資料，您可能無法完成註冊程序，或無法使用部分服務。

五、違約事項及處置
1. 如您有任何違反本服務條款之情形，如未於時間內歸還或惡意破壞容器等行為，本服務有權對您做出暫時停權或永久停權之權利，並移除您於本服務之資訊內容，如造成本公司傷害，本公司得請求損害賠償。
2. 如您所提供之個人資訊有偽冒他人名義、侵害他人智慧財產權或其他違反法律規定或公共秩序善良風俗之情形，導致產生民事、刑事或行政責任，本服務將配合檢調機關、司法機關或行政機關，提供必要的個人資料供查證。

六、免責聲明
1. 您理解並同意本服務是「依現況」與「依可用」狀態提供。除本服務條款明示規定者外，本公司均不對服務做出任何明示或默示之保證，亦不保證服務之安全性、不保證您隨時隨地均可獲得服務、不保證服務中任何缺陷或錯誤都將得到更正，也不保證您使用服務的結果將滿足您的需求。您因使用服務所生之一切利益或損失均由您自行承擔。您瞭解本服務或有因系統故障而延遲、中斷情形，或可能造成您使用不便或資料喪失、錯誤、遭人篡改或其他損失等情形，本公司將盡商業上合理努力修復系統，但您於使用時應自行採取防護措施，本公司對因使用或無法使用本服務所生之一切損害不負賠償責任，您同意不就上述事件對本公司為任何請求。

七、服務變更、終止、暫停或中斷
1. 本公司得基於任何原因，如您違反本服務條款，有權停止向您提供全部或部分服務或終止您的帳戶。終止後，您的帳戶將會關閉，而且您不得再以該帳戶群取、使用或取回該帳戶內任何檔案或內容。
2. 本公司有權隨時永久或暫時修改本服務條款或終止服務，且無須對您或任何第三方負責，亦無需個別通知。在本服務條款變更之訊息公開後，如果您繼續使用本服務，即代表您同意這些變更並願意遵守。

七、準據法及合意管轄
1. 您同意本服務條款之解釋及履行以中華民國法律為準據法。
2. 雙方如因本服務條款產生任何爭議或歧見，應先誠意協商解決，如無法於合理期間內達成協議，雙方同意以臺灣臺南地方法院為第一管轄法院。

八、其他
1. 本服務條款之標題僅係為閱讀方便而使用，並不影響本服務條款之內容及解釋。
2. 本服務條款為本公司與您之間之服務相關完整協議，並取代先前一切書面或口頭合意。
3. 非經本公司事前書面同意，您不得轉讓本服務條款之權利義務予任何第三人。
4. 本服務條款並非第三人利益契約，並未賦予任何第三人權利或利益。

最後修改日期：2019 年 4 月 17 日`;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          backgroundColor: "#f8f8f8",
          fontSize: "16px",
          fontWeight: 300,
          lineHeight: "1.6",
          flex: 1,
          padding: "8px 16px",
          overflowY: "scroll",
          whiteSpace: "pre-line",
        }}
      >
        {policyContent}
      </div>
      <div
        style={{
          display: "flex",
          flexShrink: 0,
          height: "60px",
          width: "100%",
          boxShadow: "0px -1px 1px 1px rgba(0,0,0,0.1)",
          zIndex: 1,
          padding: 0,
          margin: 0,
        }}
      >
        <Button
          size="large"
          onClick={onBack}
          style={{
            flex: 3,
            margin: "6px",
            border: "1px solid #FFCD14",
            borderRadius: "4px",
            color: "#FFCD14",
            backgroundColor: "transparent",
            height: "48px",
          }}
        >
          取消
        </Button>
        <Button
          type="primary"
          size="large"
          onClick={onNext}
          style={{
            flex: 5,
            margin: "6px 6px 6px 0",
            borderRadius: "4px",
            backgroundColor: "#FFCD14",
            borderColor: "#FFCD14",
            color: "white",
            height: "48px",
          }}
        >
          我同意
        </Button>
      </div>
    </div>
  );
}
